import React, { useState, useContext, useEffect } from "react";
import StepperNavigationButtons from "../../StepperNavigationButtons/StepperNavigationButtons";
import FormBuilder from "../FormBuilder/FormBuilder";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import { EWContext } from "../../../context/EWContext";
import { getFormAnswers } from "../../../utils/utils";
import OtherFilesTable from "../FormBuilder/UploadFiles/UploadFilesTables/OtherFilesTable";
import { customerUploadFiles, customerDeleteFiles } from "../../../services/services";

function UploadFilesForm(props) {
  const [accountState, setAccountState] = useContext(
    EWContext
  );

  const {
    questions: {
      upload: questions
    },
    answers: {
      upload: answers
    },
    baseUrl,
    customer,
    behaviors,
    previousSavedFiles,
  } = accountState;

  const [loading, setLoading] = useState(false);
  const [errorFields, setErrorFields] = useState(true);
  const [uploadFormAnswers, setUploadFormAnswers] = useState(answers);
  const { group, handleNext, handleBack } = props;

  const [maxSelectedFilesQuantity, setMaxSelectedFilesQuantity] = useState(behaviors.max_files_allowed_upload || 3);
  const previousFilesTotal = (previousSavedFiles === undefined || previousSavedFiles === "") ? [] : [...previousSavedFiles].splice(0, (behaviors.max_previous_files_allowed || 5));

  const [recentlyUploadedFiles, setRecentlyUploadedFiles] = useState(uploadFormAnswers[0]?.value || []);
  const [selectedPrevFiles, setSelectedPrevFiles] = useState(previousFilesTotal.filter(file => file.checked));

  useEffect(() => {
    if (recentlyUploadedFiles.length > 0 || selectedPrevFiles.length > 0) {
      setErrorFields(false);
      setAccountState((prevAccountState) => ({
        ...prevAccountState,
        selectedDocumentsValues: [{
          type: "file",
          value: [...recentlyUploadedFiles, ...selectedPrevFiles]
        }]
      }));
    } else if (recentlyUploadedFiles.length === 0 && selectedPrevFiles.length === 0) {
      setErrorFields(true);
      setAccountState((prevAccountState) => ({
        ...prevAccountState,
        selectedDocumentsValues: [{
          type: "file",
          value: []
        }]
      }));
    }
  }, [
    recentlyUploadedFiles,
    selectedPrevFiles,
    setAccountState
  ]);

  const handlePreviousSavedfiles = (checkboxValues) => {
    let values = [...checkboxValues.entries()];
    let files = [];
    values.forEach(value => {
      if (value[1] && !files.includes(value[0])) {
        files.push(value[0])
      }
    });
    const newPrevSavedFiles = previousFilesTotal.map(prevSavedFile => {
      return files.includes(prevSavedFile.name)
        ? { ...prevSavedFile, checked: true }
        : { ...prevSavedFile, checked: false }
    });
    const selectedValues = previousFilesTotal.filter(prevFile => files.includes(prevFile.name));
    setSelectedPrevFiles(selectedValues);
    setAccountState((prevAccountState) => ({
      ...prevAccountState,
      previousSavedFiles: newPrevSavedFiles
    }));
  }

  const handleOnFormAnswered = (questionAnswers) => {
    if (questionAnswers.uploadFile.value) {
      const maxAllowedFiles = behaviors.max_files_allowed_upload || 3;
      const quantityValue = maxAllowedFiles - questionAnswers.uploadFile.extraValues.filesCount;
      const allowedFilesQuantity = quantityValue <= 0 ? 0 : quantityValue;
      setMaxSelectedFilesQuantity(allowedFilesQuantity);
      setRecentlyUploadedFiles([...questionAnswers.uploadFile.value]);
    } else {
      setRecentlyUploadedFiles([]);
      setMaxSelectedFilesQuantity(behaviors.max_files_allowed_upload || 3);
    }
    const formAnswers = getFormAnswers(questionAnswers, questions);
    setUploadFormAnswers(formAnswers);
    setAccountState((prevAccountState) => ({
      ...prevAccountState,
      answers: {
        ...prevAccountState.answers,
        upload: [...formAnswers]
      }
    }));
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    setLoading(false);
    handleNext(true);
  };

  return (
    <FormBuilder
      questions={questions}
      answers={uploadFormAnswers}
      onFormAnswered={handleOnFormAnswered}
      handleSubmit={handleSubmit}
      formInstructions={group.instructions}
      additionalInstructions={group.additionalInstructions}
      extraInfoAfterRequired={group.extraInfoAfterRequired}
      requiredFieldsSubtitule={false}
      customConfig={{
        uploadFiles: {
          prevFilesNames: previousFilesTotal.map(file => file.name),
          maxUploadFiles: behaviors.max_files_allowed_upload || 3,
          customerUploadFiles: (file, onProgress) => { return customerUploadFiles(baseUrl, customer, file, onProgress) },
          customerDeleteFiles: (file) => { return customerDeleteFiles(baseUrl, customer, file) },
        }
      }}
    >
      <React.Fragment>
        {previousFilesTotal.length > 0 && <OtherFilesTable
          maxFilesAllowed={maxSelectedFilesQuantity}
          files={previousFilesTotal}
          handlePreviousSavedfiles={handlePreviousSavedfiles}
        />}
      </React.Fragment>
      <StepperNavigationButtons
        handleBack={handleBack}
        handleNext={() => null}
        loading={loading}
        nextButtonDisabled={errorFields}
      />
    </FormBuilder>
  );
}

export default withErrorHandler(UploadFilesForm);
